import React from 'react';
import './Reviews.css';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import ReviewItem from './ReviewItem';
import ReviewIndex from './ReviewIndex';
import Reveal from 'react-reveal/Reveal';


const Reviews = ({ review, nextHandler, prevHandler, disabled, index, count, next }) => (
  <section className="reviews" id="velemenyek">
    <Reveal effect="grow-in-bottom">
      <div className="container-fluid mw-1200 d-flex flex-column">
        <h1 className="section__name text-center">
          Rólam mondták
        </h1>
        <div className="header-sep"></div>
        <div className="row justify-content-center order-sm-1 order-2">
          <div
            className={classnames('col-2 arrow arrow--left', {
              'disabled': disabled
            })} onClick={prevHandler}
          >
            <i className="fas fa-angle-left"></i>
          </div>
          <div className="col-12 col-sm-8 text-container">

            <ReviewItem text={review.text} name={review.name} index={index} next={next} />

          </div>
          <div
            className={classnames('col-2 arrow arrow--right', {
              'disabled': disabled
            })} onClick={nextHandler}
          >
            <i className="fas fa-angle-right"></i>
          </div>
        </div>

        <ReviewIndex index={index} count={count} />

      </div>
    </Reveal>
  </section>
);


Reviews.propTypes = {
  review: PropTypes.object.isRequired,
  nextHandler: PropTypes.func.isRequired,
  prevHandler: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  index: PropTypes.number.isRequired,
  count: PropTypes.number.isRequired,
  next: PropTypes.bool.isRequired
};

export default Reviews;



// WEBPACK FOOTER //
// ./src/components/Home/Reviews/Reviews.js